import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type CostSettingCostModel from 'lumen/models/cost-setting/cost';

export default class CostSettingProfileModel extends Model {
  [Type] = 'cost-setting/profile' as const;

  @hasMany('cost-setting/cost', { async: false, inverse: 'profile' })
  declare costs: HasMany<CostSettingCostModel>;
  @attr('dayjs') declare createdAt: NonNullable<DayjsTransformReturn>;
  @attr('string', { defaultValue: '' }) declare description: string;
  @attr('string') declare name: string | null;
  @attr('dayjs') declare updatedAt: NonNullable<DayjsTransformReturn>;

  get createdAtFromNow(): string {
    return this.createdAt.fromNow();
  }

  get updatedAtFromNow(): string {
    return this.updatedAt.fromNow();
  }
}
